import { render } from "./CaseManagementReport.vue?vue&type=template&id=0a80d2a5&ts=true"
import script from "./CaseManagementReport.vue?vue&type=script&lang=ts"
export * from "./CaseManagementReport.vue?vue&type=script&lang=ts"

import "./CaseManagementReport.vue?vue&type=style&index=0&id=0a80d2a5&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__